import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import { Card } from "src/components/Layout/Card";

type ChartTooltipProps = {
  accentColor: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
};

export const ChartTooltip: React.FC<ChartTooltipProps> = ({
  accentColor,
  title,
  subtitle,
  children,
}) => {
  return (
    <Card
      accentColor={accentColor}
      shadow="md"
      gap="2"
      display="flex"
      flexDir="column"
    >
      <Flex flexDir="column">
        <Text fontWeight="bold">{title}</Text>
        {subtitle !== undefined && (
          <Text fontSize="0.825rem" color="gray.600">
            {subtitle}
          </Text>
        )}
      </Flex>
      {children}
    </Card>
  );
};
